import { useAuthenticated } from './useAuthenticated';

export function useAuthenticatedCurrentOffice() {
  const { userContext } = useAuthenticated();
  return userContext.currentOffice;
}
